module.exports = __webpack_public_path__ + "img/eres_8_steps_v2_en.2089ba44.png";